import script from "./StreetNumber.vue?vue&type=script&setup=true&lang=js"
export * from "./StreetNumber.vue?vue&type=script&setup=true&lang=js"

import "./StreetNumber.vue?vue&type=style&index=0&id=4d338a89&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d338a89"]])

export default __exports__